module.exports = "<div class=\"switch-team-modal\">\n  <div class=\"modal-header\">\n    <h4 class=\"modal-title\">{{title}}</h4>\n  </div>\n  <div class=\"modal-body\">\n    <p>{{message}}</p>\n  </div>\n  <div class=\"modal-footer wdth-100\" *ngFor=\"let action of actions; let i=index\">\n    <button type=\"button\" data-dismiss=\"modal\" (click)=\"clicked(action, index)\" class=\"medium-btn clear-btn-popup\">{{action}}</button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/custom-message/custom-message.component.html
// module id = ./src/app/custom-message/custom-message.component.html
// module chunks = main